module.exports = __webpack_public_path__ + "static/media/persona_1.24ae3f73.png";